module.exports = "https://static.zego.com/_next/static/images/hero-about-b7d427a224165380ea32cfab4216a922.jpg";